document.querySelectorAll(".faq-container_qus_ans .collapsible-trigger").forEach((item, index) => {
  item.addEventListener("click", () => {
    setTimeout(() => {
      document.querySelectorAll(".faq-container_qus_ans .collapsible-trigger").forEach((el) => {
        if (el.classList.contains("is-open")) {
          el.querySelector(".collapsible-trigger__icon").style.color = "#ffffff";
        } else {
          el.querySelector(".collapsible-trigger__icon").style.color = "#000000";
        }
      });
    });
  });
  if (item.classList.contains("is-open")) {
    item.querySelector(".collapsible-trigger__icon").style.color = "#ffffff";
  } else {
    item.querySelector(".collapsible-trigger__icon").style.color = "#000000";
  }
});

